import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import styles from './CardStateIcons.module.scss';
import { Tooltip, Badge } from '@mui/material';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import SensorDoorRoundedIcon from '@mui/icons-material/SensorDoorRounded';
import openDoor from '../../../assets/abertura-da-porta-aberta.png';


export const CardStateIcons = ({ numberOfEvents, thermoKing, door }) => {
    return (
        <div className={styles.boxIcons}>
            <Tooltip title={thermoKing === "OFF" ? "Climatização Desligada" : thermoKing === "ON" ? "Climatização Ligada" : "Climatização desligada com alarme"}>
                <AcUnitRoundedIcon
                    className={`${styles.thermoKingIcon} ${thermoKing === "OFF" ? styles.thermoKingOFF : thermoKing === "ON" ? styles.thermoKingON : styles.thermoKingOFFatention}`}
                />
            </Tooltip>

            <Tooltip title={door ? "Porta Fechada" : "Porta Aberta"}>
                {door ?
                    <SensorDoorRoundedIcon
                        className={`${styles.doorIcon} ${door ? styles.doorCloseIcon : styles.doorOpenIcon}`}
                    />
                    :
                    <img
                        src={openDoor}
                        alt="Ícone"
                        style={{
                            height: "28px",
                            width: "28px",
                        }}
                    />
                }

            </Tooltip>
            <Tooltip title="Alarmes Disparados" placement="top">
                <Badge
                    color='error'
                    showZero
                    badgeContent={numberOfEvents}
                    max={99}
                    sx={{ size: '12px' }}
                >
                    <NotificationsRoundedIcon
                        style={{ color: 'black', fontSize: '34px' }} />
                </Badge>
            </Tooltip>

        </div>
    );
}